import { Link } from 'react-router-dom';

const PHASE_TEXT: Record<number, string> = {
  1: '第一阶段（登录/权限 + 销售链）',
  2: '第二阶段（生产 / 库存 / 采购）',
  3: '第三阶段（质检 / ARCA 财务 / 审计）',
};

export function ComingSoon({ label, endpoint, phase }: { label: string; endpoint?: string; phase?: number }) {
  return (
    <section className="panel">
      <div className="panel-head">
        <div>
          <h2>{label}</h2>
          <div className="desc">该模块尚未接入本控制台</div>
        </div>
      </div>
      <div className="panel-body">
        <div className="notice warn">
          <div>
            <div style={{ fontWeight: 650, marginBottom: 4 }}>计划接入 · {phase ? PHASE_TEXT[phase] : '后续阶段'}</div>
            <div>
              核心服务已提供对应接口{endpoint ? <>（<span className="num">{endpoint}</span>）</> : null}。
              本阶段聚焦“客户 → 报价 → 合同 → 交货”销售链，逐模块替换旧管理后台；在此之前请沿用同域 <Link to="/admin">/admin</Link> 备用入口。
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
